import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { Panel, Label, Empty } from "@/components/common";
import { useApi, inr } from "@/lib/api";

const MEDAL = ["text-amber-400", "text-slate-300", "text-orange-400"];

export const Leaderboard = () => {
  const api = useApi();
  const [data, setData] = useState(null);
  useEffect(() => { api("get", "/leaderboard").then(setData).catch(() => setData({ leaders: [] })); }, [api]);
  const month = new Date().toLocaleString("en-IN", { month: "long" });
  return (
    <Panel className="mt-6" data-testid="leaderboard">
      <div className="flex items-center justify-between">
        <div><Label>Leaderboard</Label><h3 className="mt-2 font-display text-2xl font-bold text-white">Top referrers · {month}</h3></div>
        <Trophy className="h-6 w-6 text-amber-400" />
      </div>
      <div className="mt-6">
        {!data ? <p className="text-sm text-slate-500">Loading…</p> : data.leaders.length === 0 ? <Empty testId="leaderboard-empty" text="No activations yet this month — be the first on the board." /> : (
          <ol className="divide-y divide-[#1F293D]">
            {data.leaders.map((l) => (
              <li key={l.rank} data-testid={`leader-row-${l.rank}`} className={`flex items-center gap-4 py-3 ${l.is_me ? "rounded-lg bg-emerald-500/5 px-2" : ""}`}>
                <span className={`w-8 font-display text-xl font-extrabold ${MEDAL[l.rank - 1] || "text-slate-600"}`}>#{l.rank}</span>
                <span className="flex-1 text-white">{l.name}{l.is_me && <span className="ml-2 font-mono text-[10px] uppercase tracking-widest text-emerald-400">you</span>}</span>
                <span className="font-mono text-sm text-slate-400">{l.referrals} referrals</span>
                <span className="w-24 text-right font-mono text-emerald-400">{inr(l.earned)}</span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </Panel>
  );
};
